export default {"src":"/_next/static/media/ebs-logo.cd84ef6b.svg","height":44,"width":48,"blurWidth":0,"blurHeight":0};